module.exports = __webpack_public_path__ + "outdoors_paper-c851393d4b77c20691c2fa40135e8b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/outdoors_paper.png
// module id = 1583
// module chunks = 1